import { DateTime } from 'luxon';
import { Board } from '../board/board';
import { CoreItem, CoreItemBackend } from '../core-item/core-item';

export interface LeadsBackend extends CoreItemBackend {
  parentId?: string; // resume provider Id

  status: LeadsStatus;
  statusMessage?: string;
  statusTimeStr?: string;

  scheduledTimeStr?: string;
  unsafeSubData: LeadsUnsafeSubData;
}

export interface Leads extends CoreItem {
  parentId?: string; // resume provider Id

  status: LeadsStatus;
  statusMessage?: string;
  statusTimeStr?: string;

  scheduledTime?: DateTime;
  unsafeSubData: LeadsUnsafeSubData;
}

export enum WeeklyLeadsStatus {
  good = 'status-dot-good',
  warning = 'status-dot-warning',
  bad = 'status-dot-bad',
}

export enum LeadsStatus {
  linkedInInviteDraft = 'linkedInInviteDraft',
  linkedInInviteProcessing = 'linkedInInviteProcessing',
  linkedInInviteFailed = 'linkedInInviteFailed',

  linkedInInvitePending = 'linkedInInvitePending',

  linkedInSecondMessageDraft = 'linkedInSecondMessageDraft',
  linkedInSecondMessageProcessing = 'linkedInSecondMessageProcessing',
  linkedInSecondMessageSent = 'linkedInSecondMessageSent',
  linkedInSecondMessageFailed = 'linkedInSecondMessageFailed',

  linkedInResponded = 'linkedInResponded',
}

export interface LeadsUnsafeSubData {
  productId?: string;
  resumeId?: string;

  boardId?: string;

  linkedInInvitationId?: string;
  chatId?: string;
  inviteMessage?: string;
  secondMessage?: string;
}

export interface LeadsMessage {
  createdTimeStr: string;
  message: string;
  createdBy: string;
}

export interface LeadsTimeRangeData {
  board: Board;
  status: WeeklyLeadsStatus;
  startDateTime: DateTime;
  endDateTime: DateTime;
  pendingInvitationsCount: number;
  sentInvitationsCount: number;
  acceptedInvitationsCount: number;
  repliedMessageCount: number;
  industryPieOption: any;
  productPieOption: any;
  invitationFunnelOption: any;
}
